import snakeCase from 'lodash/snakeCase';

import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { VEHICLE_DELIVERY } = ANALYTICS_CATEGORIES;

export const triggerBackToPreviousButtonEvent = (action: string, category: string, enquiryId: string): void => {
	const eventPayload = getSnowplowEventPayload({
		category,
		customData: { label: enquiryId },
		name: `dlr_${snakeCase(category)}_${snakeCase(action)}`,
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerSelectedDeliveryTypeEvent = (action: string, enquiryId: string): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_DELIVERY,
		customData: { label: enquiryId },
		name: `dlr_vehicle_delivery_${snakeCase(action)}`,
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerBookDeliveryClickEvent = (enquiryId: string): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_DELIVERY,
		customData: { label: enquiryId },
		name: 'dlr_vehicle_delivery_book_delivery_button_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerTransportFaqClickEvent = (enquiryId: string): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_DELIVERY,
		customData: { label: enquiryId },
		name: 'dlr_vehicle_delivery_transport_faq_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerOpenDeliveryLocationModal = (enquiryId: string): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_DELIVERY,
		customData: { label: enquiryId },
		name: 'dlr_vehicle_delivery_open_delivery_location_modal',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerCloseDeliveryLocationModal = (enquiryId: string): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_DELIVERY,
		customData: { label: enquiryId },
		name: 'dlr_vehicle_delivery_close_delivery_location_modal',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerConfirmChangeDeliveryLocation = (enquiryId: string): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_DELIVERY,
		customData: { label: enquiryId },
		name: 'dlr_vehicle_delivery_confirm_change_delivery_location',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerTransportTermsAndConditionsClickedEvent = (enquiryId: string): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_DELIVERY,
		customData: { label: enquiryId },
		name: 'dlr_vehicle_delivery_transport_terms_and_conditions_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerPurchasesButtonEvent = (enquiryId: string): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_DELIVERY,
		customData: { label: enquiryId },
		name: 'dlr_vehicle_delivery_purchases_button_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
